export default __webpack_public_path__ + "2587fe1e5ba212e58f76bfa6f75d4f78.jpeg";